<template>
    <div v-if="deadline" :class="['fix-board', `fix-board_theme_${theme}`]">
        {{ deadline }}
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    props: ['theme'],

    computed: {
        ...mapGetters({
            deadline: 'GET_DEADLINE'
        })
    }
};
</script>

<style lang="scss">
    .fix-board {
        @include transition(opacity);
        @include font-size(p3);
        @include scale-wide(border-radius, 8);
        @include scale-wide(padding, 8 16);
        position: fixed;
        top: 110px;
        left: column(1, 36);
        background-color: $addition_5;
        pointer-events: none;

        @media #{$laptop} {
            top: 128px;
        }

        @media #{$fullhd} {
            top: vw-desk(128);
        }
    }

    .fix-board_theme_floor {
        background-image: $background-gradient;
    }
</style>
